import { Component, OnChanges, Input, Renderer2, ElementRef, SimpleChanges } from '@angular/core';
import { encapsulation } from '../encapsulation';
import { UBXButton, Toggle } from '../../models';
// import { ButtonIcon } from '../../form';

@Component({
    selector: 'ubx-button',
    templateUrl: './button.component.html',
    host: { class: 'flx f-ai:c pointer' },
    encapsulation
})
export class UBXButtonComponent implements OnChanges {
    @Input('btnType') type: string;
    @Input('btnColor') color: string;
    @Input('btnIcons') icons: string;

    constructor(
        private renderer: Renderer2,
        public el: ElementRef,
    ) { }

    ngOnChanges(changes: SimpleChanges) {
        const button = (change: string) => new UBXButton('ubx-btn', changes.type[change], changes.color[change]);
        if (changes.type && changes.color) {
            if (changes.type.currentValue && changes.color.currentValue) {
                this.setBtnClasses(Toggle.Remove, button('previousValue'));
                this.setBtnClasses(Toggle.Append, button('currentValue'));
            }
        }
    }

    private setBtnClasses(toggle: Toggle, btn: UBXButton) {
        const classes = [`${btn.name}`, `${btn.name}__${btn.type}`, `${btn.name}__${btn.type}--${btn.color}`];
        classes.forEach((name) => {
            switch (toggle) {
                case Toggle.Append:
                    this.appendClass(name);
                    break;
                case Toggle.Remove:
                    this.removeClass(name);
                    break;
            }
        });
    }

    private appendClass(name: string) {
        this.renderer.addClass(this.el.nativeElement, name);
    }
    private removeClass(name: string) {
        this.renderer.removeClass(this.el.nativeElement, name);
    }

    // setColumns(icon: ButtonIcon): number {
    //     if (!icon) {
    //         return 1;
    //     } else {
    //         if (icon.left && icon.right) {
    //             return 3;
    //         }
    //         if (icon.left || icon.right) {
    //             return 2;
    //         }
    //     }
    // }
}
